import logoImg from '../../assets/Logo.jpg'

export default function LogoMark() {
  return (
    <div className="relative inline-block shrink-0">
      {/* subtle depth/duplicate effect behind logo (scales with logo) */}
      <img
        src={logoImg}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-12 md:h-16 w-auto opacity-20 blur-sm translate-x-1 translate-y-1 object-contain"
      />

      {/* main logo */}
      <img
        src={logoImg}
        alt="Ritik Medicare"
        className="relative h-12 md:h-16 w-auto object-contain"
      />
    </div>
  )
}




